export default {
    costCenterNumbers: [],
    costCenterNumbersLoading: false
}

